import { CityTypesStateInterface } from "../actions/City/types";
import { createReducer } from "@reduxjs/toolkit";
import {
    cityConfigurationReceived,
    currentCityHasRealTimeDataReceived,
    currentCityReceived,
    getCurrentCity,
    getCurrentCityHasRealTimeData,
    setIsUserLoggedIn
} from "actions";

const initialState: CityTypesStateInterface = {
    isCurrentCityReceived: false,
    currentCity: null,
    currentCityHasRealTimeData: false,
    cityConfig: [],
    isUserLoggedIn: false
};

const city = createReducer(initialState, (builder) => {
    builder
        .addCase(currentCityReceived, (state, action) => {
            state.isCurrentCityReceived = true;
            state.currentCity = action.payload.data;
        })
        .addCase(getCurrentCity, (state) => {
            state.isCurrentCityReceived = false;
        })
        .addCase(getCurrentCityHasRealTimeData, (state) => {
            state.currentCityHasRealTimeData = false;
        })
        .addCase(currentCityHasRealTimeDataReceived, (state, action) => {
            state.currentCityHasRealTimeData = action.payload.message;
        })
        .addCase(cityConfigurationReceived, (state, action) => {
            state.cityConfig = action.payload.data;
        })
        .addCase(setIsUserLoggedIn, (state, action) => {
            state.isUserLoggedIn = action.payload.data;
        })
        .addDefaultCase((state) => state);
});

export default city;
